<div class="title">
  <!-- Optional title in header -->
  <span *ngIf="data.showTitleInHeader">{{ data.title }}</span>
    <i class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>

<div class="dialog-content">
  <div *ngIf="!data.title">{{ "Are you sure you want to delete this item?" | i18next:{item:data.component} }}</div>
  <!-- keep old behavior -->
  <div *ngIf="data.title && !data.showTitleInHeader">{{ data.title }}</div>
  <div *ngIf="data.additionalText" class="additional-text" [class]="sizeOption">{{ data.additionalText }}</div>
  <div *ngIf="data.additionalSecondText" class="additional-text" [class]="sizeOption">{{ data.additionalSecondText }}</div>
</div>

<!-- <mat-dialog-actions style="justify-content: center;">

    <button *ngIf="!data.confirmText" matButton [mat-dialog-close]="true" class="primary-button">{{ 'Delete' | i18next }}</button>
    <button *ngIf="data.confirmText" matButton [mat-dialog-close]="true" class="primary-button">{{data.confirmText}}</button>
    <button *ngIf="!data.cancelText" matButton [mat-dialog-close]="false" class="secondary-button">{{ 'Cancel' | i18next }}</button>
    <button *ngIf="data.cancelText" matButton [mat-dialog-close]="false" class="secondary-button">{{ data.cancelText }}</button>
</mat-dialog-actions> -->
<mat-dialog-actions>
    <app-basic-button type="secondary" [size]="sizeOption" (click)="closeDialog()">{{data.cancelText || ('Cancel' | i18next) }}</app-basic-button>
    <app-basic-button type="primary" [size]="sizeOption" [mat-dialog-close]="true">{{ data.confirmText || ('Delete' | i18next) }}</app-basic-button>
</mat-dialog-actions>
